import { useEffect } from "react";
import { CSS_VARIABLE_PREFIX } from "../../constants/prefix";

const useThemeStyles = (skin) => {
  useEffect(() => {
    const prefix = CSS_VARIABLE_PREFIX;

    const headTag = document.getElementsByTagName("head")[0];
    const styleTag = document.createElement("style");
    styleTag.id = "gc-root-css-variables";

    const niceBlack = "#181a1b";
    const justWhite = "#ffffff";
    const selectedBackgroundColor = "#2684FF";

    if (skin === "dark") {
      styleTag.innerHTML = `\n:root { 
        ${prefix}border-separator-color: #383d3f;
        ${prefix}table-hover-background: #2b2f31;
        ${prefix}input-light-background: ${niceBlack};
        ${prefix}light-background: ${niceBlack};
        ${prefix}dark-background: #2b2f31;
        ${prefix}dark-background-text-color: #e8e6e3;
        ${prefix}default-background: #181a1b;
        ${prefix}default-text-color: #d1cdc;
        ${prefix}emphasis-background-color: #2394fd;
        ${prefix}emphasis-text-color: ${justWhite};
        ${prefix}selected-background-color: ${selectedBackgroundColor};
        ${prefix}selected-text-color: ${justWhite};
        ${prefix}input-background-color: #333333;
      }\n`;
    } else {
      styleTag.innerHTML = `\n:root { 
        ${prefix}border-separator-color: #dee2e6;
        ${prefix}table-hover-background: #dddddd;
        ${prefix}input-light-background: ${justWhite};
        ${prefix}light-background: ${justWhite};
        ${prefix}dark-background: #dddddd;
        ${prefix}dark-background-text-color: #212529;
        ${prefix}default-background: ${justWhite};
        ${prefix}default-text-color: #212529;
        ${prefix}emphasis-background-color: #2394fd;
        ${prefix}emphasis-text-color: ${justWhite};
        ${prefix}selected-background-color: ${selectedBackgroundColor};
        ${prefix}selected-text-color: ${justWhite};
        ${prefix}input-background-color: ${justWhite};
      }\n`;
    }

    headTag.appendChild(styleTag);

    return () => {
      // Cleanup logic, remove the style tag on unmount
      headTag.removeChild(styleTag);
    };
  }, [skin]);
};

export default useThemeStyles;
